import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import ProspectosContext from '../../context/ProspectosContext'
import { ImportImage } from './ImportImage'

export const PasaporteImgComp = (props) => {


    const [dataProspecto, setProspectoData] = useContext(ProspectosContext);
    const [document, setDocument] = useState(dataProspecto.passport)

    const updatePassportInContext = useCallback(
        (document) => {
            setProspectoData(data => data = { ...data, passport: document, errorBoolPass: false });
        },
        [setProspectoData]
    )

    useEffect(() => {
        updatePassportInContext(document);

    }, [updatePassportInContext, document])

    return (
        <>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                <span className="font-weight-bold form_subtitle-label"> Frontal * </span>
                <ImportImage setImage={setDocument}
                    urlImage={document.url}
                    alt={'Credencial Toma Frontal'}
                    image={document.file}
                    classWidth='classWidth_passport'
                />
                {
                    dataProspecto.errorBoolPass ? (<div><label className="mandatory">¡ Dato necesario ! Favor de adjuntar su identificación  </label><br /></div>) : null
                }
            </div>
        </>
    )
}
